import { number } from 'prop-types';
import React, { useState } from 'react';
import {
  Button,
  Col,
  Row,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  ModalFooter,
  Label,
  Input,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

function Storage({ data, setData, numbers, setNumbers, FORM, allNumbers }) {
  const onChangeText = (value, index) => {
    let temp = [...data];
    temp[index].callerId = value;
    setData(temp);
  };
  const onRemove = idx => {
    let temp = [...data];
    temp = temp.slice(idx, idx + 1);
    setData([...temp]);
    onSettingNumbers(temp);
  };
  const onNumberSelect = (selectedNumbers, index) => {
    let temp = [...data];
    temp[index].selectedNumbers = [...selectedNumbers];
    setData(temp);
    onSettingNumbers(temp);
  };
  const onSettingNumbers = (temp = data) => {
    let newNumbers = allNumbers.filter(num => !temp.some(obj => obj.selectedNumbers.includes(num)));
    setNumbers(newNumbers);
  };
  const onSelectAll = index => {
    let temp = [...data];
    temp[index].selectedNumbers = [...temp[index].selectedNumbers, ...numbers];
    setData(temp);
    onSettingNumbers(temp);
  };
  const onUnSelectAll = index => {
    let temp = [...data];
    temp[index].selectedNumbers = [];
    setData(temp);
    onSettingNumbers(temp);
  };
  let buttonUsed = numbers.length - (allNumbers.length === numbers.length ? 1 : 0);

  return (
    <div className="p-4">
      <h2>
        Outgoing calling name display (CNAM storage) for outbound calls is turned OFF by default;
        enter a display name and select numbers to enable:
      </h2>
      {data.map((item, index) => {
        return (
          <div key={index}>
            <Row>
              {index > 0 && (
                <Col md={{ offset: 6 }}>
                  <div onClick={() => onRemove(index)} className="arrow-icon">
                    <FontAwesomeIcon icon={faTimes} />
                  </div>
                </Col>
              )}
            </Row>
            <Col sm={4}>
              <Label>Caller ID (LIDB)</Label>
              <Input
                placeholder="Caller ID (LIDB)"
                required
                type="text"
                name={'callerId' + index}
                id={'callerId' + index}
                value={item.callerId}
                onChange={e => onChangeText(e.target.value, index)}
              />
            </Col>
            <p style={{ marginTop: 10 }}>
              In box below, click to select Telephone Numbers targeted by data above.
              <br />
              To multi-select, click and drag across numbers, or use Shift or Ctrl
            </p>
            <Col md={3}>
              <div className="d-flex justify-content-between align-items-center w-100">
                <Button outline color="primary" onClick={() => onSelectAll(index)}>
                  Select All
                </Button>
                <Button outline color="primary" onClick={() => onUnSelectAll(index)}>
                  Unselect All
                </Button>
              </div>
              <select
                value={item.selectedNumbers}
                id={'selectedNumbers' + index}
                onChange={e =>
                  onNumberSelect(
                    Object.values(e.target.selectedOptions).map(item => item.value),
                    index,
                  )
                }
                multiple={true}
                style={{ width: '100%', height: 100, marginTop: 30 }}
              >
                {item.selectedNumbers.map(number => (
                  <option key={number} value={number} label={number} />
                ))}
                {numbers.map(number => (
                  <option key={number} value={number} label={number} />
                ))}
              </select>
            </Col>
          </div>
        );
      })}
      {buttonUsed > 0 && (
        <>
          <div className="d-flex" style={{ marginTop: 10 }}>
            <h2>Add Different Features To Remaining Numbers?</h2>&nbsp;
            <p>{`(You can use this button ${buttonUsed} more ${
              buttonUsed > 1 ? 'times' : 'time'
            })`}</p>
          </div>
          <Button
            outline
            color="primary"
            style={{ marginTop: 10 }}
            onClick={() => setData([...data, { ...FORM }])}
          >
            Add
          </Button>
        </>
      )}
    </div>
  );
}

export default Storage;
